import type { FC } from "react";
import { IRouteItem } from "../../types/order/IRouteItem";
import Driver from "../../models/Driver";
import { MapRoutePlanner } from "./MapRoutePlanner";

interface RoutePlannerProps {
  selectedDriver: string;
  selectedDate: Date;
  onChange: (state: {
    hasChanges: boolean;
    changesCount: number;
    routeStops: (IRouteItem & { isAvailable: boolean })[];
    availableStops: (IRouteItem & { isAvailable: boolean })[];
    hasValidationErrors: boolean;
  }) => void;
  reset?: boolean;
  onSelectDriver: (driverId: string) => void;
  drivers: Driver[];
  onSaveChanges: () => void;
  onDiscardChanges: () => void;
  isSaving: boolean;
  hasRouteChanges: boolean;
  hasRouteValidationErrors: boolean;
}

export const RoutePlanner: FC<RoutePlannerProps> = (props) => {
  return <MapRoutePlanner {...props} />;
};
